// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"n5-z"};